import AbstractViewer, {AbstractViewerProperties} from "./AbstractViewer";
import {ViewerMode} from "./ViewerMode";
import React, {ReactNode} from "react";
import MessageBox from "../../shared/components/MessageBox";
import i18next from "i18next";
import {MessageType} from "../../shared/log/MessageInterface";
import Translate from "../../shared/translation/Translate";

export interface DefaultViewerProperties extends AbstractViewerProperties {
	viewerMode: ViewerMode;
}

export default class DefaultViewer extends AbstractViewer<DefaultViewerProperties> {
	/**
	 * render component as react node
	 */
	public render(): ReactNode {
		return (
			<div className="viewer default">
				<div className="default-viewer">
					{
						(
							this.props.viewerMode === ViewerMode.PREVIEW ||
							this.props.viewerMode === ViewerMode.PORTFOLIO_PREVIEW
						) &&
						<div className="fallback-icon">
							<span className="icon icon-page"/>
						</div>
					}
					{this.props.viewerMode !== ViewerMode.PREVIEW && this.props.viewerMode !== ViewerMode.PORTFOLIO_PREVIEW &&
						<MessageBox type={MessageType.INFO} language={i18next.language}>
							<Translate {...this.props} data="viewerscreen.message.no_preview" namespace="screen"/>
						</MessageBox>
					}
				</div>
			</div>
		);
	}
}